import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const modalStyle = css`
  max-width: min(600px, 100vw - 48px);
`;

export const messageStyle = css`
  margin-bottom: ${theme.spacing(2)};
`;
